import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useMatches } from 'react-router-dom';
import { Icon } from '@nazka/nazka.mapframe.components';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';

import {
  useFlowingWater100mTimeseries,
  useStillWaterCellTimeseries,
} from '@services/query.service';

import { setGraphCollapsed } from '../PotentialGraph/potential-graph.store';

import TimelineChart, { colors } from './TimelineChart';
import { getTimelinePoints } from './timeline-graph.utils';
import './timeline-graph.css';

function TimelineGraph() {
  const matches = useMatches();
  const dispatch = useDispatch();
  const params = matches[matches.length - 1]?.params || {};

  const flowingId = params.stromendWaterStukje100mId;
  const stillCellId = params.stilstaandWaterCellId;

  const flowing = useFlowingWater100mTimeseries(flowingId);
  const still = useStillWaterCellTimeseries(stillCellId);

  const { data, isLoading } = flowingId ? flowing : still;
  const points = useMemo(() => getTimelinePoints(data), [data]);

  const handleCollapse = () => dispatch(setGraphCollapsed(true));

  return (
    <div className="graph-panel timeline-graph">
      <div className="graph-panel__header timeline-graph__header">
        <div className="timeline-graph__title">
          <h2 className="graph-panel__header__title">Tijdsgrafiek</h2>
        </div>

        <div className="timeline-graph__legend" role="group" aria-label="Legende">
          <span className="timeline-graph__legend-item">
            <span className="timeline-graph__legend-line" style={{ background: colors.deltaT }} />
            DeltaT
          </span>
          <span className="timeline-graph__legend-item">
            <span className="timeline-graph__legend-line" style={{ background: colors.potential }} />
            Bronpotentieel
          </span>
          <span className="timeline-graph__legend-item">
            <span
              className="timeline-graph__legend-line timeline-graph__legend-line--dashed"
              style={{ color: colors.heatDelivered }}
            />
            Vermogen geleverd
          </span>
        </div>

        <div className="graph-panel__header__actions">
          <button
            type="button"
            className="graph-panel__header__actions__action timeline-graph__collapse"
            onClick={handleCollapse}
            aria-label="Grafiek sluiten"
          >
            <Icon icon={faChevronDown} size="18px" />
          </button>
        </div>
      </div>

      <div className="graph-panel__content timeline-graph__content">
        {points.length > 0 && <TimelineChart points={points} />}
        {points.length === 0 && (
          <div className="timeline-graph__empty">
            {isLoading
              ? 'Tijdsgrafiek laden…'
              : 'Geen tijdreeksgegevens beschikbaar voor deze bron.'}
          </div>
        )}
      </div>
    </div>
  );
}

export default TimelineGraph;
